// React
import React, { useRef, useState } from 'react';
// External
import {
    Button, Container, Overlay, Tooltip
} from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { BiCopyAlt } from 'react-icons/bi';
// Internal
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import config from 'config/config';
// Styles
import './styles.scss';
import isEmpty from 'lodash/isEmpty';

const BookingSubmitted = (props) => {
    // const [showTooltip, setShowTooltip] = useState(false);
    // const target = useRef(null);

    // const getTrackingURL = () => {
    //     return `/booking/${props.bookingId ? props.bookingId : ''}`;
    // };

    // const getTrackingURLDisplay = () => {
    //     return `${config.SITE_URL}booking/${props.bookingId ? props.bookingId : ''}`;
    // };

    /**
     * Gets the office email from the vet's primary email address
     * 
     * @returns {String} 
     */
    const getOfficeEmail = () => {
        if (props.vetDetails && props.vetDetails.primary_email_address && !isEmpty(props.vetDetails.primary_email_address) && props.vetDetails.primary_email_address[0]) {
            return props.vetDetails.primary_email_address[0].email_address ?? '';
        }

        return '';
    }

    return (
        <div className="booking-submitted-content">
            <ContentCard>
                <Container className="nb-container">
                    <h3 className='step-title'>Booking {props.isUnsubmitted ? 'Submitted' : 'Updated'}</h3>
                    {
                        props.isUnsubmitted ?
                        <p>
                            Thank you, your booking has been submitted and should now appear in your booking history.
                            A booking confirmation has also been sent to { getOfficeEmail() }
                        </p> :
                        <p>Thank you, your booking has been updated successfully.</p>
                    }
                    {/* <p>
                        <span className="bold">Track this booking</span>
                        <span>
                            <Link to={getTrackingURL()}>{getTrackingURLDisplay()}</Link>
                        </span>
                        <Button
                            ref={target}
                            className="icon-copy"
                            onClick={() => {
                                navigator.clipboard.writeText(getTrackingURLDisplay());
                                setShowTooltip(!showTooltip);
                                setTimeout(() => {
                                    setShowTooltip(false);
                                }, 2000);
                            }}
                        >
                            <BiCopyAlt size="20" />
                        </Button>
                        <Overlay target={target.current} show={showTooltip} placement="top">
                            {(tooltipProps) => (
                                <Tooltip id="overlay-copy" className="tooltip-copy" {...tooltipProps}>
                                    Copied!
                                </Tooltip>
                            )}
                        </Overlay>
                    </p> */}
                </Container>
            </ContentCard>
        </div>
    );
};

export default withRouter(BookingSubmitted);
